// Typesense
export const TYPESENSE_PROJECTS_COLLECTION_NAME = "projects";
export const TYPESENSE_USERS_COLLECTION_NAME = "users";
export const TYPESENSE_USER_EMAILS_COLLECTION_NAME = "userEmails";
export const TYPESENSE_ORGANIZATIONS_COLLECTION_NAME = "organizations";
export const TYPESENSE_PARTS_COLLECTION_NAME = "parts";
export const TYPESENSE_PARTS_VECTORIZED_COLLECTION_NAME = "parts-vectorized";

// Accounts view collections — per-tier projections of unified account data.
// Each collection stores the same schema but with fields filtered by visibility tier.
export const TYPESENSE_ACCOUNTS_VIEW_PUBLIC_COLLECTION_NAME = "accounts-view-public";
export const TYPESENSE_ACCOUNTS_VIEW_USERS_COLLECTION_NAME = "accounts-view-users";
export const TYPESENSE_ACCOUNTS_VIEW_NETWORK_COLLECTION_NAME = "accounts-view-network";
export const TYPESENSE_ACCOUNTS_VIEW_PRIVATE_COLLECTION_NAME = "accounts-view-private";

/** All accounts-view collection names, ordered by tier (public → private). */
export const TYPESENSE_ACCOUNTS_VIEW_COLLECTION_NAMES = [
    TYPESENSE_ACCOUNTS_VIEW_PUBLIC_COLLECTION_NAME,
    TYPESENSE_ACCOUNTS_VIEW_USERS_COLLECTION_NAME,
    TYPESENSE_ACCOUNTS_VIEW_NETWORK_COLLECTION_NAME,
    TYPESENSE_ACCOUNTS_VIEW_PRIVATE_COLLECTION_NAME,
] as const;

/**
 * Public HTTPS endpoint of the primary (self-hosted) Typesense cluster.
 * Scoped keys minted for the "primary" cluster only validate against this
 * host; keys minted for "cloud" only validate against the managed cloud
 * cluster.
 */
export const TYPESENSE_PRIMARY_CLUSTER_HOST = "search.flux.ai";

export const QDRANT_PARTS_COLLECTION_NAME = "parts";
export const QDRANT_PARTS_EMBEDDING_MODEL = "text-embedding-3-small";

// `query_by` parameter we send to Typesense when searching for documents
// in profile page
export const TYPESENSE_QUERY_BY_FOR_PROFILE = "name,description,slug,owner_handle";

export const TYPESENSE_QUERY_BY_FOR_PART_LIBRARY =
    "name,nameSuffixes,description,part_type,owner_name,owner_handle,defaultValueSynonyms";

export const TYPESENSE_QUERY_BY_WEIGHTS_FOR_PART_LIBRARY = "4,3,2,1,1,1,1";

export const TYPESENSE_QUERY_BY_FOR_PART_LIBRARY_WITH_INDEXED_FIELDS =
    "name,nameSuffixes,description,properties.value,properties.unit,terminal_names,owner_name,owner_handle,part_type,defaultValueSynonyms";

export const TYPESENSE_QUERY_BY_WEIGHTS_FOR_PART_LIBRARY_WITH_INDEXED_FIELDS = "4,3,2,1,1,1,1,1,1,1";
